<template>
  <v-container>
    <v-divider></v-divider>
    <v-row justify="center"> </v-row>
    <v-row justify="center">
      <v-col cols="6">
        <v-data-table dense :items="employeeCategories" :headers="tableHeaders">
          <template v-slot:top>
            <v-row justify="center">
              <v-col cols="10">
                <h2 class="marco--text">Employee Categories</h2>
              </v-col>
              <v-col cols="2">
                <v-btn small color="success" @click="createNewItem()"
                  >New</v-btn
                >
              </v-col>
            </v-row>
          </template>
          <template #item.edit="{item}">
            <v-icon small color="green" @click="setItem(item)"
              >mdi-pencil</v-icon
            >
          </template>
          <template #item.delete="{item}">
            <v-icon small color="red" @click="deleteEmployeeCategory(item)"
              >mdi-delete</v-icon
            >
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" persistent max-width="40%">
      <v-card>
        <v-card-title class="marco white--text"
          >Create Employee Category</v-card-title
        >
        <v-card-text>
          <v-container fluid>
            <v-row class="my-1">
              <v-col>
                <v-combobox
                  :items="childCompanyOptions"
                  v-model="employeeCategoryForm.company"
                  label="Company"
                ></v-combobox>
                <div v-for="i in userInputs.length" :key="i">
                  <v-text-field
                    v-if="userInputs[i - 1].type === 'text'"
                    :key="userInputs[i - 1].text"
                    v-model="employeeCategoryForm[userInputs[i - 1].variable]"
                    :counter="255"
                    :label="userInputs[i - 1].text"
                    required
                  ></v-text-field>
                  <v-textarea
                    v-if="userInputs[i - 1].type === 'textarea'"
                    v-model="employeeCategoryForm[userInputs[i - 1].variable]"
                    :counter="255"
                    :label="userInputs[i - 1].text"
                    required
                  ></v-textarea>
                </div>
              </v-col>
            </v-row>

            <v-row> </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="error" v-on:click="dialog = false">Cancel</v-btn>
          <v-btn
            v-if="employeeCategoryForm.id"
            text
            color="warning"
            v-on:click="postEmployeeCategory()"
            >Update</v-btn
          >
          <v-btn
            v-if="!employeeCategoryForm.id"
            text
            color="success"
            v-on:click="postEmployeeCategory()"
            >Create</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      options: [
        { value: "new", text: "Create New" },
        { value: "list", text: "List" },
      ],

      employeeCategoryForm: {
        id: null,
        company: null,
        companyOption: null,
        name: null,
        alternative_name: null,
      },
      userInputs: [
        { text: "Category Name", variable: "name", type: "text" },
        {
          text: "Alternative Name",
          variable: "alternative_name",
          type: "text",
        },
      ],
      showTableColumns: ["id", "company_name", "name", "edit", "delete"],
    };
  },
  methods: {
    postEmployeeCategory: function() {
      let form = new FormData();
      form.append("id", this.employeeCategoryForm.id);
      form.append("company", this.employeeCategoryForm.company.value);
      form.append("name", this.employeeCategoryForm.name);
      form.append(
        "alternative_name",
        this.employeeCategoryForm.alternative_name
      );
      this.$store.dispatch("company/postEmployeeCategory", form);
      this.dialog = false;
    },
    deleteEmployeeCategory(item) {
      this.$store.dispatch("company/deleteEmployeeCategory", item.id);
    },
    createNewItem: function() {
      this.clearItem();
      this.dialog = true;
    },
    setItem: function(item) {
      this.$store.dispatch("company/setEmployeeCategory", item);
      this.employeeCategoryForm = {
        id: this.selectedEmployeeCategory.id,
        company: null,
        name: this.selectedEmployeeCategory.name,
        alternative_name: this.selectedEmployeeCategory.alternative_name,
      };
      this.employeeCategoryForm.company = {
        text: this.selectedEmployeeCategory.company_name,
        value: this.selectedEmployeeCategory.id,
      };
      this.dialog = true;
    },
    clearItem: function() {
      this.$store.dispatch("company/setEmployeeCategory", null);
      this.employeeCategoryForm.id = null;
      this.employeeCategoryForm.company = null;
      this.employeeCategoryForm.name = null;
      this.employeeCategoryForm.alternative_name = null;
    },
  },
  computed: {
    childCompanies() {
      return this.$store.state.company.childCompanies;
    },
    childCompanyOptions() {
      let data = this.childCompanies;
      let options = [];
      data.forEach((item) => {
        options.push({ text: item.legal_name, value: item.id });
      });
      console.log(options);
      return options;
    },
    employeeCategories() {
      return this.$store.state.company.employeeCategories;
    },
    selectedEmployeeCategory() {
      return this.$store.state.company.selectedEmployeeCategory;
    },
    tableHeaders() {
      let headers = [];
      let data = this.employeeCategories;
      let tableColumns = this.showTableColumns;

      console.log(data[0]);
      if (data[0]) {
        let fields = Object.keys(data[0]);
        fields.push("edit");
        fields.push("delete");

        console.log(fields);
        fields.forEach((field) => {
          if (tableColumns.includes(field)) {
            let field_txt = field.replace("_", " ").split(" ");
            console.log(field_txt);
            field_txt = field_txt.map((f) => {
              return f.charAt(0).toUpperCase() + f.slice(1);
            });
            field_txt = field_txt.join(" ");
            headers.push({ text: field_txt, value: field });
          }
        });
      }
      console.log(headers);
      return headers;
    },
  },
  mounted: function() {
    this.$store.dispatch("company/getChildCompanies");
    this.$store.dispatch("company/getEmployeeCategories");
  },
};
</script>

<style scoped>
.controlButton {
  width: 120px;
  height: 50px;
  border-radius: 25px;
  margin: 10px;
}

.pane {
  width: 100vh;
  /* border: 1px solid lightgrey; */
  padding: 15px;
  box-shadow: 0 0 11px rgba(33, 33, 33, 0.2);
}

.app-card {
  width: 300px;
}
.app-card img {
  width: 200px;
  align-content: center;
}
</style>
